<!--
  我的订单
  Lovi 2020-06-23
-->
<template>
  <div class="w100">
    <van-nav-bar :fixed="true" left-arrow @click-left="_back">
      <div slot="title" @click="changeFilterFlag">
        <span>{{ $t("life.myOrder") }}</span>
        <van-icon :class="{ rotate: statusFlag }" name="arrow-down" />
      </div>
    </van-nav-bar>
    <div
      class="scroll-wrapper"
      :class="{
        noCrad: !orderList.length && getListFlag
      }"
    >
      <div v-if="!orderList.length && getListFlag" class="noCard-wrap">
        <img src="@/assets/images/public/pic_kong@2x.png" />
        <p class="text-gray">{{ $t("common.noData") }}</p>
      </div>
      <scroll
        v-if="orderList.length && getListFlag"
        ref="scroll"
        :data="orderList"
        :pullUpLoad="true"
        :pullDownRefresh="true"
        @pullingDown="pullingDown"
        @pullingUp="pullingUp"
      >
        <div class="order-wrap">
          <div
            class="order-list"
            v-for="(item, index) in orderList"
            :key="index"
            @click="toDetail(item.order_id)"
          >
            <div class="item">
              <div class="image"><img :src="httpUrl + item.image" /></div>
              <div class="info">
                <h3 class="text-hidden">{{ item.shop_name }}</h3>
                <p class="time text-gray">{{ item.createtime }}</p>
                <p class="pro-desc text-hidden">{{ item.remarks }}</p>
              </div>
              <div class="status">
                <h5>
                  {{ item.status_name }}
                </h5>
                <span>{{ item.total_price }}P</span>
              </div>
            </div>
            <status
              :data="item"
              :evaluateFlag.sync="evaluateFlag"
              :evaluateData.sync="evaluateData"
              @request="getMyOrder"
            />
          </div>
        </div>
      </scroll>
    </div>

    <van-popup
      v-model="statusFlag"
      class="popup-header"
      overlay-class="overlay-header"
      position="top"
    >
      <div class="filter-list">
        <div
          class="item"
          :class="{ active: item.key === key }"
          v-for="(item, index) in statusList"
          :key="index"
          @click="clickFilter(item.key)"
        >
          <span>{{ item.name }}</span>
        </div>
      </div>
    </van-popup>

    <transition name="slide">
      <evaluate
        v-if="evaluateFlag"
        :evaluateFlag.sync="evaluateFlag"
        :data="evaluateData"
        @getEvaluate="getMyOrder"
      />
    </transition>
  </div>
</template>

<script>
import Evaluate from "./evaluate";
import Status from "./status";
export default {
  name: "order",
  meta: {
    service: false // 客服
  },
  components: {
    Evaluate,
    Status
  },
  data() {
    return {
      statusFlag: false,
      statusList: [],
      key: "",
      page: 1,
      orderList: [],
      getListFlag: false,
      evaluateFlag: false, // 评价
      evaluateData: {}
    };
  },
  created() {
    this.getOrderStatus();
    this.getMyOrder();
  },
  mounted() {},
  computed: {},
  methods: {
    changeFilterFlag() {
      // 改变Flag
      this.statusFlag = !this.statusFlag;
    },
    clickFilter(key) {
      // 筛选条件
      if (!this.statusList.length) {
        return false;
      }
      this.statusFlag = !this.statusFlag;
      this.key = key;
      this.getMyOrder();
    },
    toDetail(id) {
      // 详情
      this.$router.push({
        path: "/orderDetail",
        name: "orderDetail",
        query: { id: id }
      });
    },
    pullingDown() {
      // 下拉刷新
      this.page = 1;
      this.getMyOrder();
    },
    pullingUp() {
      // 上拉加载
      let vm = this;
      if (vm.pullUpLoadFlag) {
        vm.$refs.scroll.forceUpdate(false);
        return;
      }
      vm.page += 1;
      vm.getMyOrder(1);
    },
    getOrderStatus() {
      // 获取状态列表
      let vm = this;
      vm.$post("/app/help/myOrderStatus", {}, { loading: true }).then(res => {
        console.log("myOrderStatus", res);
        vm.statusList = res;
      });
    },
    getMyOrder(flag) {
      // 获取订单列表
      let vm = this;
      let loading = true;
      vm.getListFlag = false;
      if (flag) {
        loading = false;
        vm.getListFlag = true;
      }
      let params = {};
      params.type = vm.key;
      params.page = vm.page;
      vm.$post("/app/order/getMyOrder", params, { loading: loading }).then(
        res => {
          console.log("getMyOrder", res);
          vm.getListFlag = true;
          if (vm.page == 1) {
            vm.orderList = res;
          } else {
            vm.orderList = vm.orderList.concat(res);
          }
          if (res.length < 10) {
            vm.pullUpLoadFlag = true;
          } else {
            vm.pullUpLoadFlag = false;
          }
        }
      );
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
/deep/.popup-header {
  top: 44px;
}
/deep/.van-nav-bar {
  .van-nav-bar__title {
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 1.2;
    }
  }
  .van-icon-arrow-down {
    margin-left: 2px;
    transition: transform 0.5s;
    &.rotate {
      transform: rotate(180deg);
    }
  }
}
.filter-list {
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
  padding: 5px;
  .item {
    width: 25%;
    padding: 5px;
    &.active {
      span {
        color: #2042ab;
        border-color: #2042ab;
      }
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 25px;
      line-height: 1;
      color: #5c5c5c;
      border: 1.1px solid #5c5c5c;
      border-radius: 4px;
    }
  }
}
.scroll-wrapper {
  background: #f4f4f4;
  .order-wrap {
    padding: 1.1px 0;
  }
}
.order-list {
  margin: 10px;
  padding: 10px;
  background: #fff;
  border-radius: 8px;
  .item {
    display: flex;
    justify-content: flex-start;
    line-height: 1.2;
    .image {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      width: 60px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .info {
      flex: 1;
      overflow: hidden;
      h3 {
        font-size: 14px;
      }
      p {
        padding-top: 5px;
      }
      .time {
        font-size: 10px;
      }
      .pro-desc {
        color: #555;
      }
    }
    .status {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: right;
      font-size: 14px;
      span {
        margin-top: 10px;
      }
    }
  }
  /deep/.operate {
    margin-top: 5px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
